import React                from 'react';
import Loading              from 'react-loading';
import { displayDistance }  from './../classes/Distance';
import PlaceItem            from './PlaceItem'

class Closest extends PlaceItem {

    renderSmall = (item, clickEvent) => {
        return (
            <p
            className="tap-event strap-text fs-12"
            onTouchTap={ clickEvent.bind(this, item) }
            >
                <span>
                    Nearest to you { displayDistance(item.distance) }:<br />
                    <strong>{ item.name }</strong><br />
                </span>
            </p>
        );
    };

    renderLarge = (item, clickEvent) => {
        return (
            <p
                className="tap-event strap-text fs-14"
                onTouchTap={ clickEvent.bind(this, item) }
            >
                <span>
                    Nearest to you:<br />
                    <strong>{ item.name }</strong><br />
                    { displayDistance(item.distance) }
                </span>
            </p>
        )
    };

    render() {
        if (this.props.displayClosest)
        {
            let { item } = this.props.closest;

            if (this.props.closest.fetched)
            {
                let clickEvent;

                if ('trail' === item.type)
                {
                    clickEvent = this.onTrailSelected;
                }
                else
                {
                    clickEvent = this.onPlaceSelected;
                }

                if ('small' === this.props.version)
                {
                    return this.renderSmall(item, clickEvent);
                }
                else
                {
                    return this.renderLarge(item, clickEvent);
                }
            }
            else
            {
                return (<Loading type="bubbles" color={ this.props.theme.body.text } width={ 50 } height={ 50 } />)
            }
        }

        return null;
    }
}

export default Closest;


// WEBPACK FOOTER //
// ./src/components/Closest.js